import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { Provider } from "react-redux";
import store from "./app/store";
import { msalConfig } from "./auth/authConfig";
import { PublicClientApplication } from "@azure/msal-browser";
import { MsalProvider } from "@azure/msal-react";
import OneTabEnforcer from "./components/OneTabEnforcer/OneTabEnforcer";
import AxiosManager from "./components/AxiosManager/AxiosManager";
import { TranslationProvider } from "./contexts/TranslationContext";

const root = ReactDOM.createRoot(document.getElementById("root") as HTMLElement);

const msalInstance = new PublicClientApplication(msalConfig);

if (process.env.REACT_APP_ENV === "Prd") {
  console.log = () => { };
  console.warn = () => { };
}

root.render(
  <Provider store={store}>
    <TranslationProvider>
      <OneTabEnforcer>
        <MsalProvider instance={msalInstance}>
          <AxiosManager />
          <App />
        </MsalProvider>
      </OneTabEnforcer>
    </TranslationProvider>
  </Provider >
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
